const forms = Array.from(document.querySelectorAll('.js-freeform'));

forms.forEach((form) => {
    form.addEventListener('freeform-ready', (event) => {
        const instance = event.target.freeform;
        const loader = form.querySelector('button[type="submit"] svg');

        instance.addOnSubmitCallback(() => {
            // Add spinner
            loader.classList.remove('hidden');

            // Submit the form
            return true;
        });

        instance.addOnAfterAjaxSubmit(() => {
            // Regardless success remove loading state
            form.classList.toggle('hidden');
        });

        instance.addOnSuccessfulAjaxSubmit(() => {
            form.parentNode.querySelector('.success-message').classList.toggle('hidden');
        });

        instance.addOnFailedAjaxSubmit(() => {
            form.parentNode.querySelector('.error-message').classList.toggle('hidden');
        });
    });
});
